import { Win, Big, Row, Empty, money } from "./Win";
import { IndianRupee, CalendarRange, Wallet, Trophy } from "lucide-react";

const pct = (v) => `${v ?? 0}%`;

export function BusinessWin({ d, expanded }) {
  const b = d.business;
  return (
    <Win title="Total Business" icon={IndianRupee} to="/reports?open=bill_report" testid="win-business">
      <Big testid="stat-sales">{money(b.total_sales)}</Big>
      <p className="text-xs text-muted-foreground mt-1" data-testid="stat-bills">{b.bill_count} bills · avg {money(b.avg_bill)}</p>
      <div className="mt-4">
        <Row label="New customers" value={<>{b.new_customers} <span className="text-muted-foreground text-xs">({pct(b.new_pct)})</span></>} testid="cust-new" />
        <Row label="Repeat customers" value={<>{b.repeat_customers} <span className="text-muted-foreground text-xs">({pct(b.repeat_pct)})</span></>} testid="cust-repeat" />
        <Row label="Unique customers" value={b.unique_customers} testid="cust-total" strong />
      </div>
    </Win>
  );
}

export function MonthCompareWin({ d }) {
  const m = d.month_compare;
  const up = m.difference >= 0;
  return (
    <Win title="Last Month vs This Month" icon={CalendarRange} to="/reports?open=daily_revenue" testid="win-month">
      <Big testid="month-this" className={up ? "text-primary" : "text-red-400"}>{money(m.this_month.business)}</Big>
      <p className="text-xs text-muted-foreground mt-1">This month to date · {m.this_month.bills} bills</p>
      <div className="mt-4">
        <Row label="Last month" value={money(m.last_month.business)} testid="month-last" muted />
        <Row label="This month (MTD)" value={money(m.this_month.business)} />
        <Row label="Difference" value={<span className={up ? "text-green-400" : "text-red-400"}>{up ? "+" : "−"}{money(Math.abs(m.difference))}</span>} testid="month-diff" strong />
        <Row label={up ? "Growth" : "Decline"} value={<span className={up ? "text-green-400" : "text-red-400"}>{up ? "▲" : "▼"} {Math.abs(m.growth_pct)}%</span>} testid="month-growth" strong />
      </div>
    </Win>
  );
}

export function ExpenseWin({ d }) {
  const e = d.expense;
  return (
    <Win title="Total Expense" icon={Wallet} to="/expense-report" testid="win-expense">
      <Big testid="expense-total">{money(e.total)}</Big>
      <p className="text-xs text-muted-foreground mt-1">{e.count} entries</p>
      <div className="mt-4">
        {e.by_category.length ? e.by_category.slice(0, 5).map((c) => (
          <Row key={c.category} label={c.category} value={money(c.amount)} testid={`expense-cat-${c.category}`} muted />
        )) : <Empty text="No expenses recorded in this period." />}
        {e.by_category.length > 5 && <p className="text-xs text-muted-foreground mt-1">+{e.by_category.length - 5} more categories</p>}
      </div>
    </Win>
  );
}

export function TopStaffWin({ d, onStaff }) {
  return (
    <Win title="Top 5 Staff" icon={Trophy} to="/reports?open=staff_summary" testid="win-top-staff">
      {d.top_staff.length ? (
        <ol className="space-y-2 mt-1">
          {d.top_staff.map((s) => (
            <li key={s.staff_id} data-testid={`top-staff-${s.rank}`}
              onClick={(e) => { e.stopPropagation(); onStaff(s); }}
              className="flex items-center gap-3 text-sm rounded-sm px-1 py-1 -mx-1 hover:bg-secondary/60 cursor-pointer">
              <span className={`font-display text-lg w-5 text-center ${s.rank === 1 ? "text-primary" : "text-muted-foreground"}`}>{s.rank}</span>
              <div className="flex-1 min-w-0">
                <p className="truncate font-medium">{s.name}</p>
                <p className="text-[11px] text-muted-foreground truncate">{s.designation} · {s.branch}</p>
              </div>
              <span className="text-primary font-medium whitespace-nowrap">{money(s.business)}</span>
            </li>
          ))}
        </ol>
      ) : <Empty text="No service business in this period." />}
    </Win>
  );
}
